/** @jsxImportSource @emotion/react */
import MenuButton from 'apollo-react/components/MenuButton'
import Badge from 'apollo-react/components/Badge'

const More = ({ headerBar }) => {
  const moreList = () => {
    let itemArray = []

    headerBar?.action_items?.show_feature &&
      itemArray.push({
        label: 'Action Items',
        onClick: () => {
          window.location.href = headerBar?.action_items?.path
        },
      })
    itemArray.push({
      label: 'Email History',
      onClick: () => {
        window.location.href = headerBar?.meta?.email_history_path
      },
    })
    headerBar?.reports?.show_feature &&
      itemArray.push({
        label: reportCountBadge(headerBar?.reports?.display_count),
        onClick: () => {
          window.location.href = headerBar?.reports?.path
        },
      })
    itemArray.push({
      label: 'Study Profile',
      onClick: () => {
        window.location.href = headerBar?.meta?.view_profile_path
      },
    })
    headerBar?.workflow_tasks?.show_feature &&
      itemArray.push({
        label: 'Workflow Tasks',
        onClick: () => {
          window.location.href = headerBar?.workflow_tasks?.path
        },
      })
    headerBar?.my_bulk_actions?.show_feature &&
      itemArray.push({
        label: 'My Bulk Actions',
        onClick: () => {
          window.location.href = headerBar?.my_bulk_actions?.path
        },
      })
    return itemArray
  }

  const reportCountBadge = displayCount => {
    return displayCount > 0 ? (
      <Badge
        sx={{
          '& .MuiBadge-badge': {
            right: '-35px',
            top: '0px',
            backgroundColor: 'rgb(7, 104, 253)',
          },
        }}
        badgeContent={displayCount}
      >
        Reports
      </Badge>
    ) : (
      'Reports'
    )
  }

  return (
    <MenuButton
      buttonText="My Actions"
      sx={{
        '&.MuiButtonBase-root': {
          border: 'none',
        },
      }}
      menuItems={moreList()}
    />
  )
}

export default More
